// @flow
import React from 'react';

import PopupContainer from '../PopupContainer';
import CreateRoutePopupForm from '../CreateRoutePopupForm';


const CreateRoutePopup = ({ routeId }: { routeId?: number}) => (
  <PopupContainer size="big">
    <CreateRoutePopupForm routeId={routeId} />
  </PopupContainer>
);


export default CreateRoutePopup;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateRoutePopupContent/index.jsx